import { IMapLibrePolygonsStyle } from "@ryde/controls";
import { rydeColors } from "@ryde/theme";

export const POLYGON_MAP_DEFAULT_ZOOM = 13;

export const POLYGON_MAP_FIT_BOUNDS_PADDING_PX = 24;

/**
 * The look the Leaflet editor and viewer drew polygons in — red, a light fill and a 2px outline. Kept as
 * separate values rather than a Leaflet `PathOptions` object now that both the editor and the viewer take
 * MapLibre paint properties.
 */
export const POLYGON_MAP_EDITOR_COLOR = rydeColors.red;
export const POLYGON_MAP_FILL_OPACITY = 0.3;
export const POLYGON_MAP_WEIGHT = 2;

/**
 * The read-only viewer's share of that style. It never hovers and is never dimmed, so only the resting
 * fill and stroke are set.
 */
export const POLYGON_VIEWER_STYLE: Partial<IMapLibrePolygonsStyle> = {
  fillOpacity: POLYGON_MAP_FILL_OPACITY,
  weight: POLYGON_MAP_WEIGHT,
};
